import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Info Cards',
  name: 'infoCards',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Content Cards',
      name: 'contentCards',
      type: 'array',
      of: [{ type: 'contentCard' }],
      validation: (Rule) => Rule.length(3),
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
    }),
  ],
})